<template>
  <div>
    <div class="title">
      <h1 style="font-weight: bold;">物流信息</h1>
      <img src="@/assets/imgs/order/3.1 返回1@2x(1).png" alt="" @click="toggleShow">
    </div>
    <div class="commodity-info" v-if="showDetails">
      <div class="message">
        <span class="info-title">交货方式</span>
        <span class="info-value">{{orderDetail.deliveryMode | shipModeStatus}}</span>
      </div>
      <div class="message">
        <span class="info-title">交货区域</span>
        <span class="info-value">{{orderDetail.deliveryAddress}}</span>
      </div>
      <div class="message">
        <span class="info-title">交货仓库</span>
        <span class="info-value">{{ orderDetail.warehouseName }}</span>
      </div>
      <div class="message">
        <span class="info-title">仓库地址</span>
        <span class="info-value">{{ orderDetail.warehouseAddress }}</span>
      </div>
      <div class="message">
        <span class="info-title">联系人</span>
        <span class="info-value">{{ order.contactPersonName || orderDetail.warehouseContactName }}</span>
      </div>
      <div class="message">
        <span class="info-title">联系电话</span>
        <span class="info-value">{{ order.contactPersonPhone || orderDetail.warehouseContactTel }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDeliveryTypeCard",
  props: {
    orderDetail: Object,
    order: Object,
    title: {
      type: String,
      default: "物流信息",
    },
  },
  data() {
    return {
      deliveryType: "1",
      showDetails: true, // 控制价格详情是否显示
    };
  },
  filters: {
    shipModeStatus: function (value) {
      switch (value) {
        case "1":
          return "自提";
        case "2":
          return "配送";
      }
    },
  },
  methods: {
    toggleShow() {
      this.showDetails = !this.showDetails; // 切换显示状态
    },
  }
};
</script>
<style lang="stylus" scoped>
.title {
  margin: 32px 0;
  padding: 0 34px;
  display: flex;
  justify-content: space-between;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.commodity-info {
  overflow: hidden;
  background-color: #fff;
  margin: 32px 0;
  padding: 0 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;

  .message {
    margin: 40px 0;

    .info-title {
      margin-right: 48px;
      color: #666666;
    }

    .info-value {
      color: #333;
    }
  }

  .message-title {
    margin-top: 48px;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }
}
</style>
